import HealthIndicatorSelector from './HealthIndicatorSelector.jsx';

export default HealthIndicatorSelector;